import clsx from 'clsx';
import { Field, FieldProps } from 'formik';

import { Label, LABEL_TYPE, PARAGRAPH2_NORMAL_CLASSES } from '@/components/generic';
import {
  DEFAULT_TEXTAREA_STYLES,
  INVALID_TEXTAREA_STYLES,
  TEXTAREA_CONTAINER_STYLES,
  TEXTAREA_ERROR_CONTAINER_STYLES,
  TEXTAREA_FIELD_LABEL_CONTAINER_STYLES,
  VALID_TEXTAREA_STYLES
} from '@/components/generic/Textarea/textarea-config';

type TextareaProps = {
  id: string;
  label: string;
  errorMessage?: string;
  isInvalid?: boolean;
  disabled?: boolean;
  isRequired?: boolean;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  handleFocus?: () => void;
  readOnly?: boolean;
};

export const Textarea = ({
  id,
  label,
  errorMessage,
  isInvalid,
  disabled,
  isRequired,
  placeholder,
  className,
  containerClassName,
  handleFocus,
  readOnly = false
}: TextareaProps) => {
  return (
    <div className={clsx(TEXTAREA_CONTAINER_STYLES, containerClassName)}>
      <div className={clsx(TEXTAREA_FIELD_LABEL_CONTAINER_STYLES, 'flex h-full flex-col')}>
        <Label text={`${label}${isRequired ? ' *' : ''}`} type={LABEL_TYPE.PARAGRAPH2} />
        <Field name={id} resize={disabled}>
          {({ field }: FieldProps) => (
            <textarea
              {...field}
              id={id}
              onFocus={handleFocus}
              readOnly={readOnly}
              placeholder={placeholder ?? label}
              className={`${DEFAULT_TEXTAREA_STYLES} ${PARAGRAPH2_NORMAL_CLASSES} ${
                isInvalid ? INVALID_TEXTAREA_STYLES : VALID_TEXTAREA_STYLES
              } ${className}`}
            />
          )}
        </Field>
        {(isInvalid || errorMessage) && (
          <div className={TEXTAREA_ERROR_CONTAINER_STYLES}>
            <Label text={errorMessage} type={LABEL_TYPE.PARAGRAPH_ERROR} />
          </div>
        )}
      </div>
    </div>
  );
};
